export default __webpack_public_path__ + "static/media/one_col_layout.b2ef0ffb.svg";